import { Alert } from "reactstrap"

import React, { useEffect } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import TaskNotification from "./TaskNotification"
import { dismissError } from "../actions"

const ERROR_AUTO_DISMISS_MS = 10000

function ErrorNotification({ error, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, ERROR_AUTO_DISMISS_MS)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return (
    <Alert color="danger" toggle={onDismiss}>
      {error.message}
    </Alert>
  )
}

class Notifications extends React.Component {
  render = () => {
    const { tasks, user, app } = this.props
    const errors = (app && app.errors) || []
    return (
      <div
        className="position-fixed mx-3 notification-div"
        style={{ width: "250px", right: "0px", top: "50px", zIndex: 1060 }}
      >
        {errors.map((error) => (
          <ErrorNotification
            key={error.id}
            error={error}
            onDismiss={() => this.props.dismissError(error.id)}
          />
        ))}
        {user && user.loggedIn
          ? tasks.tasks
              .filter((t) => t.showNotification)
              .map((task) => <TaskNotification key={task._id} task={task} />)
          : null}
      </div>
    )
  }
}

export default connect(
  (s) => ({
    tasks: s.tasks,
    user: s.user,
    app: s.app,
  }),
  { dismissError }
)(withTranslation()(Notifications))
